import { getEffectiveLimit, LIMIT_MESSAGES } from './limit-resolution.esm.js';
import '@superfunnel/types/usage-limits';

/**
 * Local Limit Checking
 *
 * Pure function for checking usage limits on the client side (no Firestore, no throwing).
 * Uses pre-fetched account, subscription, and usage data.
 */
/**
 * Check if an operation would exceed the usage limit using pre-fetched data.
 * This is the client-side equivalent of `checkLimit` — no async, no Firestore.
 *
 * @param metric - The usage metric to check
 * @param currentUsage - Current usage count (from RTDB subscription)
 * @param account - The account document
 * @param subscription - The subscription document (optional)
 * @param increment - The amount to add (default: 1)
 * @returns Result object with allowed flag and details
 */
function canPerformOperationLocal(metric, currentUsage, account, subscription, increment = 1) {
    const limit = getEffectiveLimit(metric, account, subscription);
    if (limit === null) {
        return {
            allowed: true,
            current: currentUsage,
            limit: null,
            remaining: null,
            message: '',
        };
    }
    // Calculate effective limit with buffer
    const buffer = account.limits?.buffer ?? 0;
    let effectiveLimit = limit * (1 + buffer);
    // For AI tokens, include top-up balance (both are in credits)
    if (metric === 'aiTokens') {
        effectiveLimit += account.topUpBalance ?? 0;
    }
    else {
        // For resource counts, floor the effective limit
        effectiveLimit = Math.floor(effectiveLimit);
    }
    const remaining = effectiveLimit - currentUsage;
    const allowed = currentUsage + increment <= effectiveLimit;
    return {
        allowed,
        current: currentUsage,
        limit: effectiveLimit,
        remaining: Math.max(0, remaining),
        message: allowed ? '' : LIMIT_MESSAGES[metric],
    };
}

export { canPerformOperationLocal };
//# sourceMappingURL=check-limit.esm.js.map
